<template>
  <b-modal
    id="modal-acc-order"
    hide-footer
    hide-header
    centered
  >
    <div class="text-center p-1">
      <!-- Warning Icon -->
      <div class="mb-6">
        <b-img
          width="98"
          center
          src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
        />
      </div>

      <!-- Title -->
      <h4 class="mb-6 text-xl font-bold text-gray-900">
        Konfirmasi Data Order ini?
      </h4>

      <!-- Order Details Card -->
      <div class="bg-gray-50 rounded-xl p-1 mb-6 text-left border border-gray-200">
        <!-- Tanggal Order -->
        <div class="flex justify-between items-start py-[8px]  gap-4">
          <span class="text-sm font-medium text-gray-600 min-w-[120px] flex-shrink-0">Tanggal Order</span>
          <span class="text-sm text-gray-900 flex-1 text-left">
            {{ DAY_MONTH_YEAR(order.order_date) }} <small class="text-gray-500">{{ TIME(order.order_date) }}</small> <span class="px-1">|</span>
            <span class="inline-block  py-[4px] rounded-xl text-xs font-medium">{{ order.cs_name }} (AI)</span>
          </span>
        </div>

        <!-- Nomor Telepon -->
        <div class="flex justify-between items-start py-[8px]  gap-4">
          <span class="text-sm font-medium text-gray-600 min-w-[120px] flex-shrink-0">Nomor Telepon</span>
          <span class="text-sm text-gray-900 flex-1 text-left">{{ order.phone }}</span>
        </div>

        <!-- Alamat Pengirim -->
        <div class="flex justify-between items-start py-[8px]  gap-4">
          <span class="text-sm font-medium text-gray-600 min-w-[120px] flex-shrink-0">Alamat Pengirim</span>
          <span class="text-sm text-gray-900 flex-1 text-left">
            {{ order.origin_address }}
          </span>
        </div>

        <!-- Alamat Tujuan -->
        <div class="flex justify-between items-start py-[8px]  gap-4">
          <span class="text-sm font-medium text-gray-600 min-w-[120px] flex-shrink-0">Alamat Tujuan</span>
          <span class="text-sm text-gray-900 flex-1 text-left">
            {{ order.destination_address }}
          </span>
        </div>

        <!-- Alamat Tambahan -->
        <div class="flex justify-between items-start py-[8px]  gap-4">
          <span class="text-sm font-medium text-gray-600 min-w-[120px] flex-shrink-0">Alamat Tambahan</span>
          <span class="text-sm text-gray-900 flex-1 text-left">
            {{ order.additional_address || '-' }}
          </span>
        </div>

        <!-- Pelanggan -->
        <div class="flex justify-between items-start py-[8px]  gap-4">
          <span class="text-sm font-medium text-gray-600 min-w-[120px] flex-shrink-0">Pelanggan</span>
          <span class="text-sm text-gray-900 flex-1 text-left">
            {{ order.customer }}<span class="px-1">|</span>
            <span class="inline-flex items-center gap-1 px-[6px] bg-[#FFECE9] border border-gray-300  rounded-2xl text-xs font-medium">
              <img
                :src="order.shipment"
                alt="JNE"
                class="w-4 h-3 object-contain"
              >
              {{ order.shipment_name }} Regular
            </span>
          </span>
        </div>

        <!-- Produk -->
        <div class="flex justify-between items-start mb-1  gap-4">
          <span class="text-sm font-medium text-gray-600 min-w-[120px] flex-shrink-0">Produk</span>
          <div
            class="grid h-[157px] w-[300px] border overflow-y-auto grid-cols-1 p-1 gap-2"
          >
            <div
              v-for="(product, index) in order.products"
              :key="index"
              class="flex items-start gap-3 justify-start"
            >
              <div class="w-8 h-8 bg-gray-100 border border-gray-300 rounded-md flex items-center justify-center">
                <b-img
                  :src="product.image_url"
                  alt="Product Image"
                  class="object-contain"
                />
              </div>
              <div class="text-left">
                <div class="text-sm font-medium text-gray-900 mb-0.5">
                  {{ product.product_name }} <strong>x{{ product.qty }}</strong>
                </div>
                <div class="text-xs text-primary">
                  {{ product.variant_name }}, {{ product.color }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Total Pembayaran -->
        <div class="flex justify-between items-start mb-1 gap-4">
          <span class="text-sm font-medium text-gray-600 min-w-[120px] flex-shrink-0">
            Total Pembayaran
          </span>
          <span class="text-base text-gray-900 flex-1 text-left font-bold">
            {{ IDR(order.total_amount) }}
            <span class="px-1">|</span>
            <span class="inline-block text-yellow-800 rounded-xl text-xs font-semibold">{{ order.payment_method === 'COD' ? order.payment_method : 'Transfer' }}</span>
          </span>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="flex items-center gap-1">
        <div class="w-full">
          <b-button
            block
            class="!h-[38px]"
            variant="outline-primary"
            @click="rejectOrder"
          >
            Tolak Order
          </b-button>
        </div>
        <div class="w-full">
          <b-button
            variant="primary"
            block
            class=""
            @click="acceptOrder"
          >
            Proses Order
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
import order from '@/navigation/vertical/order'
import apiSetStatusOrderAi from '@/views/pages/komship/order/OrderAi/service/api.order.service'
import { IDR } from '@/libs/currency'
import { DAY_MONTH_YEAR, TIME } from '@/libs/formatDate'

export default {
  name: 'ModalAcceptOrder',
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      IDR,
      DAY_MONTH_YEAR,
      TIME,
    }
  },
  methods: {
    async acceptOrder() {
      try {
        await apiSetStatusOrderAi.apiSetStatusOrderAi(this.order.id, 'accept')
        this.$emit('order:accepted', this.order.id)
      } catch (error) {
        console.error('Error accepting order:', error)
        this.$toast_error({ message: 'Gagal menerima order. Silakan coba lagi.' })
        return
      }
      this.$bvModal.hide('modal-acc-order')
    },
    async rejectOrder() {
      try {
        await apiSetStatusOrderAi.apiSetStatusOrderAi(this.order.id, 'reject')
        this.$emit('order:rejected', this.order.id)
      } catch (error) {
        console.error('Error rejecting order:', error)
        this.$toast_error({ message: 'Gagal menolak order. Silakan coba lagi.' })
        return
      }
      this.$bvModal.hide('modal-acc-order')
    },
  },
}
</script>
